var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 76,
    viewBox: "0 0 90 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8328 1.98866C86.8194 -0.384045 89.2913 7.15405 82.6201 13.2207C75.4567 19.735 64.2032 17.5926 55.0401 20.7215C46.0178 23.8023 39.2576 30.4898 35.1721 38.2268C34.2006 40.0671 32.9069 44.0197 32.7397 46.106C31.3003 64.162 59.9301 52.9219 47.9456 41.0368C46.5638 39.6666 44.284 38.6721 42.3698 38.3027C27.125 35.3612 35.4671 62.6261 21.1709 68.4458C16.9817 70.0112 3.92464 70.5494 5.436 73.6096C5.52937 73.7999 2.28709 72.5253 2.50797 70.8844C4.05926 71.3649 5.03201 73.3097 6.30564 68.2715C5.20658 68.8067 0.0134553 71.2707 1.48608 71.9824C2.07866 72.2686 8.43347 74.6393 8.84124 74.3269",
    stroke: "#4CB963",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownOut);
export default __webpack_public_path__ + "static/media/arrow-down-out.3589591b04e992445e94c793afd58e4d.svg";
export { ForwardRef as ReactComponent };